import { Confirmation } from "components/Confirmation";
import { Success } from "components/Success";
import { Warning } from "components/Warning";
import { AppNav, Header, User } from "components/lib";
import { AccountModal } from "components/modals/AccountModal";
import { CompanyModal } from "components/modals/CompanyModal";
import { BoundModal } from "components/modals/BoundModal";
import { DocumentModal } from "components/modals/DocumentModal";
import { EditDocumentModal } from "components/modals/EditDocumentModal";
import { EndorsementsModal } from "components/modals/Endorsements";
import { NoteModal } from "components/modals/NoteModal";
import { NotificationModal } from "components/modals/NotificationModal";
import { PullPolicyModal } from "components/modals/PullPolicyModal";
import { QuotePDFModal } from "components/modals/QuotePDFModal";
import { QuotesModal } from "components/modals/QuotesModal";
import { RequestedBindModal } from "components/modals/RequestedBindModal";
import { UserModal } from "components/modals/UserModal";
import { ServiceModal } from "components/modals/ServiceModal";
import { CloseTicketModal } from "components/modals/CloseTicket";
import { MessageTemplatesModal } from "components/modals/MessageTemplatesModal";
import { Fragment } from "react";
import Style from "./app.module.scss";
import TicketIssueModal from "components/modals/TicketIssueModal";
import AddTicketIssuesModal from "components/modals/AddTicketIssuesModal";
import { ReopenTicketModal } from "components/modals/ReopenTicket";

import { EmailQuoteModal } from "../../modals/EmailQuoteModal";
import { RenewalModal } from "../../modals/RenewalModal";
import RenewalIssueModal from "../../modals/RenewalIssueModal";
import { RenewalStatusModal } from "../../modals/RenewalStatusModal";
import AddRenewalIssuesModal from "../../modals/AddRenewalIssuesModal";
import { BindRequestModal } from "../../modals/BindRequestModal";
import BindRequestIssueModal from "../../modals/BindRequestModal/BindRequestIssueModal";
import AddBindRequestIssuesModal from "../../modals/BindRequestModal/AddBindRequestIssuesModal";
import { BindRequestStatusModal } from "../../modals/BindRequestModal/BindRequestStatusModal";

import { CreateEndorsementModal } from "components/modals/CreateEndorsementModal";
import AddEndorsementIssueModal from "components/modals/AddEndorsementIssueModal";
import EndorsementStatusModal from "components/modals/EndorsementStatusModal";
import { CreatePolicyModal } from "components/modals/CreatePolicyModal";
import { CommissionModal } from "components/modals/CommissionModal";

export function AppLayout(props) {
  return (
    <Fragment>
      <CommissionModal />
      <Confirmation />
      <QuotesModal />
      <RequestedBindModal />
      <BoundModal />
      <EndorsementsModal />
      <UserModal />
      <RenewalModal />
      <RenewalIssueModal />
      <AccountModal />
      <CompanyModal />
      <Success />
      <NoteModal />
      <DocumentModal />
      <EditDocumentModal />
      <QuotePDFModal />
      <NotificationModal />
      <PullPolicyModal />
      <Warning />
      <ServiceModal />
      <CloseTicketModal />
      <TicketIssueModal />
      <AddTicketIssuesModal />
      <ReopenTicketModal />

      <EmailQuoteModal />
      <RenewalStatusModal />
      <AddRenewalIssuesModal />
      <BindRequestModal />
      <BindRequestIssueModal />
      <AddBindRequestIssuesModal />
      <BindRequestStatusModal />

      <CreateEndorsementModal />
      <AddEndorsementIssueModal />
      <EndorsementStatusModal />
      <CreatePolicyModal />
      <MessageTemplatesModal />

      <AppNav
        items={[
          {
            label: "Dashboard",
            icon: "grid",
            link: "/admin/dashboard",
          },
          {
            label: "Quotes",
            icon: "dollar-sign",
            link: "/admin/quote",
          },
          {
            label: "Commercial\nSubmissions",
            icon: "dollar-sign",
            link: "/admin/quote-submission/view",
          },
          {
            label: "Personal\nSubmissions",
            icon: "user",
            link: "/admin/personal-submission/view",
          },
          {
            label: "Service Center",
            icon: "tool",
            link: "/admin/service_center",
          },
          {
            label: "Bind Requests",
            icon: "file-plus",
            link: "/admin/requestedbind",
          },
          {
            label: "Renewals",
            icon: "refresh-cw",
            link: "/admin/renewal",
          },
          {
            label: "Endorsements",
            icon: "plus-circle",
            link: "/admin/endorsements",
          },
          {
            label: "Policies",
            icon: "file-text",
            link: "/admin/policies",
          },
          { label: "Users", icon: "users", link: "/admin/users" },
          {
            label: "Accounts",
            icon: "credit-card",
            link: "/admin/agencies",
          },
          {
            label: "Compliance",
            icon: "shield",
            link: "/admin/compliance",
          },

          {
            label: "Resources",
            icon: "help-circle",
            link: "/admin/resources",
          },
          { label: "Links", icon: "link", link: "/admin/management" },
        ]}
        fixedItems={[
          // Profile disabled as per client request
        ]}
      />

      <main className={Style.app}>
        <Header title={props.title}>
          <User />
        </Header>

        {<props.children {...props.data} />}
      </main>
    </Fragment>
  );
}
